import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.category.isUncategorizedCategory}}
  <p class="warning">
    {{d-icon "exclamation-triangle"}}
    {{html-safe
      (i18n
        "category.uncategorized_general_warning"
        settingLink=this.uncategorizedSiteSettingLink
        customizeLink=this.customizeTextContentLink
      )
    }}
  </p>
{{/if}}

<form>
  <CategoryNameFields @category={{this.category}} @tagName="" />

  {{#if this.canSelectParentCategory}}
    <section class="field parent-category">
      <label>{{i18n "category.parent"}}</label>
      <CategoryChooser
        @value={{this.category.parent_category_id}}
        @allowSubCategories={{true}}
        @allowRestrictedCategories={{true}}
        @onChange={{fn (mut this.category.parent_category_id)}}
        @options={{hash
          allowUncategorized=false
          excludeCategoryId=this.category.id
          autoInsertNoneItem=true
          none=true
        }}
      />
    </section>
  {{/if}}

  {{#if this.subCategories}}
    <section class="field subcategories">
      <label>{{i18n "categories.subcategories"}}</label>
      {{#each this.subCategories as |s|}}
        {{category-badge s hideParent="true"}}
      {{/each}}
    </section>
  {{/if}}

  {{#if this.showDescription}}
    <section class="field description">
      <label>{{i18n "category.description"}}</label>
      {{#if this.category.description}}
        {{html-safe this.category.description}}
      {{else}}
        {{i18n "category.no_description"}}
      {{/if}}
      {{#if this.category.topic_url}}
        <br />
        <DButton
          @action={{this.showCategoryTopic}}
          @icon="pencil-alt"
          @label="category.change_in_category_topic"
          class="btn-default edit-category-description"
        />
      {{/if}}
    </section>
  {{/if}}

  <section class="field category-colors">
    <label>{{i18n "category.badge_colors"}}</label>
    <div class="category-color-editor">
      {{html-safe this.categoryBadgePreview}}

      <section class="field">
        <span class="color-title">{{i18n "category.background_color"}}:</span>
        <div class="colorpicker-wrapper">
          <ColorInput
            @hexValue={{this.category.color}}
            @valid={{this.category.colorValid}}
          />
          <ColorPicker
            @colors={{this.backgroundColors}}
            @usedColors={{this.usedBackgroundColors}}
            @value={{this.category.color}}
          />
        </div>
      </section>

      <section class="field">
        <span class="color-title">{{i18n "category.foreground_color"}}:</span>
        <div class="colorpicker-wrapper edit-text-color">
          <ColorInput @hexValue={{this.category.text_color}} />
          <ColorPicker
            @colors={{this.foregroundColors}}
            @value={{this.category.text_color}}
            @id="edit-text-color"
          />
        </div>
      </section>
    </div>
  </section>
</form>
*/
{
  "id": "bha+meTo",
  "block": "[[[41,[30,0,[\"category\",\"isUncategorizedCategory\"]],[[[1,\"  \"],[10,2],[14,0,\"warning\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"exclamation-triangle\"],null]],[1,\"\\n    \"],[1,[28,[35,2],[[28,[37,3],[\"category.uncategorized_general_warning\"],[[\"settingLink\",\"customizeLink\"],[[30,0,[\"uncategorizedSiteSettingLink\"]],[30,0,[\"customizeTextContentLink\"]]]]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,\"form\"],[12],[1,\"\\n  \"],[8,[39,4],null,[[\"@category\",\"@tagName\"],[[30,0,[\"category\"]],\"\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"canSelectParentCategory\"]],[[[1,\"    \"],[10,\"section\"],[14,0,\"field parent-category\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,3],[\"category.parent\"],null]],[13],[1,\"\\n      \"],[8,[39,5],null,[[\"@value\",\"@allowSubCategories\",\"@allowRestrictedCategories\",\"@onChange\",\"@options\"],[[30,0,[\"category\",\"parent_category_id\"]],true,true,[28,[37,6],[[28,[37,7],[[30,0,[\"category\",\"parent_category_id\"]]],null]],null],[28,[37,8],null,[[\"allowUncategorized\",\"excludeCategoryId\",\"autoInsertNoneItem\",\"none\"],[false,[30,0,[\"category\",\"id\"]],true,true]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"subCategories\"]],[[[1,\"    \"],[10,\"section\"],[14,0,\"field subcategories\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,3],[\"categories.subcategories\"],null]],[13],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"subCategories\"]]],null]],null],null,[[[1,\"        \"],[1,[28,[35,11],[[30,1]],[[\"hideParent\"],[\"true\"]]]],[1,\"\\n\"]],[1]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showDescription\"]],[[[1,\"    \"],[10,\"section\"],[14,0,\"field description\"],[12],[1,\"\\n      \"],[10,\"label\"],[12],[1,[28,[35,3],[\"category.description\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"category\",\"description\"]],[[[1,\"        \"],[1,[28,[35,2],[[30,0,[\"category\",\"description\"]]],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,3],[\"category.no_description\"],null]],[1,\"\\n\"]],[]]],[41,[30,0,[\"category\",\"topic_url\"]],[[[1,\"        \"],[10,\"br\"],[12],[13],[1,\"\\n        \"],[8,[39,12],[[24,0,\"btn-default edit-category-description\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"showCategoryTopic\"]],\"pencil-alt\",\"category.change_in_category_topic\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,\"section\"],[14,0,\"field category-colors\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[1,[28,[35,3],[\"category.badge_colors\"],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"category-color-editor\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[[30,0,[\"categoryBadgePreview\"]]],null]],[1,\"\\n\\n      \"],[10,\"section\"],[14,0,\"field\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"color-title\"],[12],[1,[28,[35,3],[\"category.background_color\"],null]],[1,\":\"],[13],[1,\"\\n        \"],[10,0],[14,0,\"colorpicker-wrapper\"],[12],[1,\"\\n          \"],[8,[39,13],null,[[\"@hexValue\",\"@valid\"],[[30,0,[\"category\",\"color\"]],[30,0,[\"category\",\"colorValid\"]]]],null],[1,\"\\n          \"],[8,[39,14],null,[[\"@colors\",\"@usedColors\",\"@value\"],[[30,0,[\"backgroundColors\"]],[30,0,[\"usedBackgroundColors\"]],[30,0,[\"category\",\"color\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"section\"],[14,0,\"field\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"color-title\"],[12],[1,[28,[35,3],[\"category.foreground_color\"],null]],[1,\":\"],[13],[1,\"\\n        \"],[10,0],[14,0,\"colorpicker-wrapper edit-text-color\"],[12],[1,\"\\n          \"],[8,[39,13],null,[[\"@hexValue\"],[[30,0,[\"category\",\"text_color\"]]]],null],[1,\"\\n          \"],[8,[39,14],null,[[\"@colors\",\"@value\",\"@id\"],[[30,0,[\"foregroundColors\"]],[30,0,[\"category\",\"text_color\"]],\"edit-text-color\"]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"s\"],false,[\"if\",\"d-icon\",\"html-safe\",\"i18n\",\"category-name-fields\",\"category-chooser\",\"fn\",\"mut\",\"hash\",\"each\",\"-track-array\",\"category-badge\",\"d-button\",\"color-input\",\"color-picker\"]]",
  "moduleName": "discourse/components/edit-category-general.hbs",
  "isStrictMode": false
});